import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../api'
import type { ClientEntityRef } from '../../types/agentTypes'

// `enabled` should be the superuser flag: the endpoint 403s for everyone else.
export const useClientEntities = (enabled = true) => {
  const {
    data: clientEntities = [],
    isLoading: isLoadingClientEntities,
    error: clientEntitiesError,
  } = useQuery<ClientEntityRef[], Error>({
    queryKey: ['client-entities'],
    queryFn: apiClient.clientEntity.fetchClientEntities,
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  })

  return {
    clientEntities,
    isLoadingClientEntities,
    clientEntitiesError: clientEntitiesError?.message || null,
  }
}
